module.exports = {"width":512,"height":512,"entries":["card-image-bg"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-bg.json
// module id = 271
// module chunks = 0